const QUERY_PARAMATER_KEY_LANGUAGE = "l";

const URL_DEVELOPER_PAGE_ANDROID = "https://play.google.com/store/apps/dev?id=6960406449796335038";

const URL_DEVELOPER_PAGE_IOS = "https://itunes.apple.com/developer/utku-uysal/id1226022329";

const CONTACT_EMAIL = "wordsyapp@gmail.com";
const APP_NAME = "Tobo app";

//Social Links
const INSTAGRAM_URL = "https://www.instagram.com/tobo_languages/";
const TWITTER_URL = "https://twitter.com/AppWordsy";
const FACEBOOK_URL = "https://www.facebook.com/Wordsy-856315454555457";
const YOUTUBE_URL = "http://bit.ly/youtube-voc-up-tv";

const ALL_LANGUAGES = {
  enUS: "en-US",
  deDE: "de-DE",
  trTR: "tr-TR",
  esES: "es-ES",
  frFR: "fr-FR",
  ruRU: "ru-RU",
  itIT: "it-IT",
  nlNL: "nl-NL",
  svSE: "sv-SE",
  ukUA: "uk-UA",
  koKR: "ko-KR",
  plPL: "pl-PL",
  jaJP: "ja-JP",
  csCZ: "cs-CZ",
  huHU: "hu-HU",
  elGR: "el-GR",
  iwIL: "iw-IL",
  zhCN: "zh-CN",
  ptBR: "pt-BR",
  ptPT: "pt-PT",
  bgBG: "bg-BG",
};

const LANGUAGE_NAME_KEYS_ENGLISH = {
  [ALL_LANGUAGES.deDE]: "German",
  [ALL_LANGUAGES.esES]: "Spanish",
  [ALL_LANGUAGES.frFR]: "French",
  [ALL_LANGUAGES.ruRU]: "Russian",
  [ALL_LANGUAGES.itIT]: "Italian",
  [ALL_LANGUAGES.nlNL]: "Dutch",
  [ALL_LANGUAGES.svSE]: "Swedish",
  [ALL_LANGUAGES.trTR]: "Turkish",
  [ALL_LANGUAGES.ukUA]: "Ukrainian",
  [ALL_LANGUAGES.koKR]: "Korean",
  [ALL_LANGUAGES.jaJP]: "Japanese",
  [ALL_LANGUAGES.elGR]: "Greek",
  [ALL_LANGUAGES.zhCN]: "Chinese",
  [ALL_LANGUAGES.ptPT]: "Portuguese",
  [ALL_LANGUAGES.plPL]: "Polish",
  [ALL_LANGUAGES.iwIL]: "Hebrew",
  [ALL_LANGUAGES.ptBR]: "Brazilian Portuguese",
};

const LANGUAGE_BG_COLORS = {
  [ALL_LANGUAGES.enUS]: "#868e9b",
  [ALL_LANGUAGES.deDE]: "#03738C",
  [ALL_LANGUAGES.esES]: "#6593a6",
  [ALL_LANGUAGES.frFR]: "#58595b",
  [ALL_LANGUAGES.ruRU]: "#3772A6",
  [ALL_LANGUAGES.itIT]: "#a2842d",
  [ALL_LANGUAGES.nlNL]: "#D97D48",
  [ALL_LANGUAGES.svSE]: "#497a70",
  [ALL_LANGUAGES.trTR]: "#1565c0",
  [ALL_LANGUAGES.ukUA]: "#707253",
  [ALL_LANGUAGES.koKR]: "#cf0a0a",
  [ALL_LANGUAGES.plPL]: "#6a4b3f",
  [ALL_LANGUAGES.jaJP]: "#447a93",
  [ALL_LANGUAGES.csCZ]: "#3b0245",
  [ALL_LANGUAGES.huHU]: "#05887c",
  [ALL_LANGUAGES.elGR]: "#433d3d",
  [ALL_LANGUAGES.zhCN]: "#8a2100",
  [ALL_LANGUAGES.ptBR]: "#a49300",
  [ALL_LANGUAGES.ptPT]: "#32254b",
  [ALL_LANGUAGES.iwIL]: "#918989",
};

const WORD_PAGES_SUPPORTED_LANG_USERS = [
  ALL_LANGUAGES.enUS,
  ALL_LANGUAGES.trTR,
  ALL_LANGUAGES.ruRU,
  ALL_LANGUAGES.deDE,
  ALL_LANGUAGES.frFR,
  ALL_LANGUAGES.ukUA,
  ALL_LANGUAGES.esES,
  ALL_LANGUAGES.itIT,
];

const LANGS_WITH_WORD_PRO = [
  ALL_LANGUAGES.ruRU,
  ALL_LANGUAGES.ukUA,
  ALL_LANGUAGES.koKR,
  ALL_LANGUAGES.jaJP,
  ALL_LANGUAGES.elGR,
  ALL_LANGUAGES.zhCN,
  ALL_LANGUAGES.iwIL,
  ALL_LANGUAGES.bgBG,
];

const FLAG_KEYS = {
  "de-DE": "germany",
  "en-US": "usa",
  "es-ES": "spain",
  "fr-FR": "france",
  "ru-RU": "russia",
  "it-IT": "italy",
  "nl-NL": "netherlands",
  "sv-SE": "sweden",
  "tr-TR": "turkey",
  "uk-UA": "ukraine",
  "ko-KR": "south-korea",
  "pl-PL": "poland",
  [ALL_LANGUAGES.jaJP]: "japan",
  [ALL_LANGUAGES.csCZ]: "czech-republic",
  [ALL_LANGUAGES.huHU]: "hungary",
  [ALL_LANGUAGES.elGR]: "greece",
  [ALL_LANGUAGES.zhCN]: "china",
  [ALL_LANGUAGES.ptBR]: "brazil",
  [ALL_LANGUAGES.ptPT]: "portugal",
  [ALL_LANGUAGES.iwIL]: "israel",
};

const ARTICLE_REGEX_EN = /^to\s/i;
const ARTICLE_REGEX_DE = /^(der\s|die\s|das\s)/i;
const ARTICLE_REGEX_ES = /^(el\s|la\s|los\s|las\s)/i;
const ARTICLE_REGEX_IT = /^(i\s|il\s|la\s|lo\s|le\s|gli\s|l')/i;
const ARTICLE_REGEX_FR = /^(la\s|le\s|l'|les\s)/i;
const ARTICLE_REGEX_RO = /^a\s/i;
const ARTICLE_REGEX_DA = /^at\s/i;
const ARTICLE_REGEX_PTBR = /^(o\s|a\s)/i;
const ARTICLE_REGEX_PTPT = /^(o\s|a\s)/i;
const ARTICLE_REGEX_SV = /^att\s/i;
const ARTICLE_REGEX_NL = /^(de\s|het\s)/i;
const ARTICLE_REGEX_AF = /^om\ste\s/i;
const ARTICLE_REGEX_EL = /^(το\s|η\s|ο\s|τα\s|οι\s)/i;

const REGEX_ARTICLE_OBJ = {
  [ALL_LANGUAGES.deDE]: ARTICLE_REGEX_DE,
  [ALL_LANGUAGES.esES]: ARTICLE_REGEX_ES,
  [ALL_LANGUAGES.itIT]: ARTICLE_REGEX_IT,
  [ALL_LANGUAGES.frFR]: ARTICLE_REGEX_FR,
  [ALL_LANGUAGES.ptBR]: ARTICLE_REGEX_PTBR,
  [ALL_LANGUAGES.ptPT]: ARTICLE_REGEX_PTPT,
  [ALL_LANGUAGES.nlNL]: ARTICLE_REGEX_NL,
  [ALL_LANGUAGES.elGR]: ARTICLE_REGEX_EL,
};

const AVAILABLE_APPS = [
  {
    key: "de",
    title: "German",
    androidID: "com.topgermanwordsapp",
    iosID: "1312643833",
    iconKey: "germany",
  },
  {
    key: "fr",
    title: "French",
    androidID: "com.learn.common.french.words",
    iosID: "1457750865",
    iconKey: "france",
  },
  {
    key: "es",
    title: "Spanish",
    androidID: "com.learn.common.spanish.words",
    iosID: "1458994129",
    iconKey: "spain",
  },
  {
    key: "pt-BR",
    title: "Portuguese",
    longTitle: "Brazilian Portuguese",
    androidID: "com.learn.common.brazilian.portuguese.vocabulary.words.learning.phrases",
    iosID: "1484402392",
    iconKey: "brazil",
  },
  {
    key: "ru",
    title: "Russian",
    androidID: "com.learn.common.russian.words",
    iosID: "1458996776",
    iconKey: "russia",
  },
  {
    key: "it",
    title: "Italian",
    androidID: "com.learn.common.italian.words",
    iosID: "1458994627",
    iconKey: "italy",
  },
  {
    key: "en",
    title: "English",
    androidID: "com.learnenglishwordsapp",
    iosID: "1358119362",
    iconKey: "usa",
  },
  {
    key: "cs",
    title: "Czech",
    androidID: "com.learn.common.czech.vocabulary.words.learning.phrases",
    iosID: "1484401221",
    iconKey: "czech-republic",
  },
  {
    key: "tr",
    title: "Turkish",
    androidID: "com.learn.common.turkish.words",
    iosID: "1386954430",
    iconKey: "turkey",
  },
  {
    key: "ro",
    title: "Romanian",
    androidID: "com.learn.common.romanian.vocabulary.words.learning.phrases",
    iosID: "1484402210",
    iconKey: "romania",
  },
  {
    key: "pl",
    title: "Polish",
    androidID: "com.learn.common.polish.vocabulary.words.learning.phrases",
    iosID: "1454970316",
    iconKey: "poland",
  },
  {
    key: "sv",
    title: "Swedish",
    androidID: "com.learn.common.swedish.vocabulary.words.learning.phrases",
    iosID: "1484402864",
    iconKey: "sweden",
  },
  {
    key: "el",
    title: "Greek",
    androidID: "com.learn.common.greek.vocabulary.words.learning.phrases",
    iosID: "1484402220",
    iconKey: "greece",
  },
  {
    key: "da",
    title: "Danish",
    androidID: "com.learn.common.danish.vocabulary.words.learning.phrases",
    iosID: "1484402842",
    iconKey: "denmark",
  },
  {
    key: "nl",
    title: "Dutch",
    androidID: "com.learn.common.dutch.vocabulary.words.learning.phrases",
    iosID: "1461671926",
    iconKey: "netherlands",
  },
  {
    key: "uk",
    title: "Ukrainian",
    androidID: "com.learn.common.ukrainian.vocabulary.words.learning.phrases",
    iosID: "1484403151",
    iconKey: "ukraine",
  },
  {
    key: "zh-CN",
    title: "Chinese",
    androidID: "com.learn.common.chinese.vocabulary.words.learning.phrases",
    iosID: "1484403328",
    iconKey: "china",
  },
  {
    key: "cr",
    title: "Croatian",
    androidID: "com.learn.common.croatian.vocabulary.words.learning.phrases",
    iosID: "1484402384",
    iconKey: "croatia",
  },
  {
    key: "ar",
    title: "Arabic",
    androidID: "com.learn.common.arabic.vocabulary.words.learning.phrases",
    iosID: "1484409558",
    iconKey: "saudi-arabia",
  },
  {
    key: "no",
    title: "Norwegian",
    androidID: "com.learn.common.norwegian.vocabulary.words.learning.phrases",
    iosID: "1484409247",
    iconKey: "norway",
  },
  {
    key: "hu",
    title: "Hungarian",
    androidID: "com.learn.common.hungarian.vocabulary.words.learning.phrases",
    iosID: "1484408851",
    iconKey: "hungary",
  },
  {
    key: "ind",
    title: "Indonesian",
    androidID: "com.learn.common.indonesian.vocabulary.words.learning.phrases",
    iosID: "1484403538",
    iconKey: "indonesia",
  },
  {
    key: "fi",
    title: "Finnish",
    androidID: "com.learn.common.finnish.vocabulary.words.learning.phrases",
    iosID: "1484408970",
    iconKey: "finland",
  },
  {
    key: "ko",
    title: "Korean",
    androidID: "com.learn.common.korean.vocabulary.words.learning.phrases",
    iosID: "1484409292",
    iconKey: "south-korea",
  },
  {
    key: "sk",
    title: "Slovak",
    androidID: "com.learn.common.slovak.vocabulary.words.learning.phrases",
    iosID: "1520463656",
    iconKey: "slovakia",
  },
  {
    key: "ja",
    title: "Japanese",
    androidID: "com.learn.common.japanese.vocabulary.words.learning.phrases",
    iosID: "1519672644",
    iconKey: "japan",
  },
  {
    key: "af",
    title: "Afrikaans",
    androidID: "com.learn.common.afrikaans.vocabulary.words.learning.phrases",
    iosID: "1520463861",
    iconKey: "south-africa",
  },
  {
    key: "hi",
    title: "Hindi",
    androidID: "com.learn.common.hindi.vocabulary.words.learning.phrases",
    iosID: "1520463983",
    iconKey: "india",
  },
  {
    key: "pt-PT",
    title: "EU Portuguese",
    longTitle: "European Portuguese",
    androidID: "com.learn.common.european.portuguese.vocabulary.words.learning.phrases",
    iosID: "1520464093",
    iconKey: "portugal",
  },
  {
    key: "vi",
    title: "Vietnamese",
    androidID: "com.learn.common.vietnamese.vocabulary.words.learning.phrases",
    iosID: "1520463810",
    iconKey: "vietnam",
  },
  {
    key: "is",
    title: "Icelandic",
    androidID: "com.learn.common.icelandic.vocabulary.words.learning.phrases",
    iosID: "1520464225",
    iconKey: "iceland",
  },
  {
    key: "th",
    title: "Thai",
    androidID: "com.learn.common.thai.vocabulary.words.learning.phrases",
    iosID: "1520464228",
    iconKey: "thailand",
  },
  {
    key: "iw",
    title: "Hebrew",
    androidID: "com.learn.common.hebrew.vocabulary.words.learning.phrases",
    iosID: "1520464461",
    iconKey: "israel",
  },
  {
    key: "fil",
    title: "Filipino",
    androidID: "com.learn.common.filipino.vocabulary.words.learning.phrases",
    iosID: "1520464779",
    iconKey: "philippines",
  },
  {
    key: "bg",
    title: "Bulgarian",
    androidID: "com.learn.common.bulgarian.vocabulary.words.learning.phrases",
    iosID: "1520464660",
    iconKey: "bulgaria",
  },
].map((item) => ({
  ...item,
  longTitle: item.longTitle || item.title,
}));

module.exports = {
  QUERY_PARAMATER_KEY_LANGUAGE,
  URL_DEVELOPER_PAGE_ANDROID,
  URL_DEVELOPER_PAGE_IOS,
  CONTACT_EMAIL,
  APP_NAME,
  INSTAGRAM_URL,
  TWITTER_URL,
  FACEBOOK_URL,
  YOUTUBE_URL,
  ALL_LANGUAGES,
  LANGUAGE_BG_COLORS,
  WORD_PAGES_SUPPORTED_LANG_USERS,
  AVAILABLE_APPS,
  FLAG_KEYS,
  LANGS_WITH_WORD_PRO,
  REGEX_ARTICLE_OBJ,
  LANGUAGE_NAME_KEYS_ENGLISH,
};
